import { NavLink } from 'react-router-dom'
import noDataIcon from '../assets/images/no-data.svg'

const NoReports = () => {
  return (
    <div className='text-center'>
      <img src={noDataIcon} width={176} height={176} />
      <h1>No Reports</h1>
      <p>
        Switch to the Brain tab and start uploading your data to generate
        insightful reports.
      </p>
      <NavLink
        to='/dashboard/screening'
        className='common-btn px-4 py-2 text-white'
      >
        Start Uploading
      </NavLink>
    </div>
  )
}

export default NoReports
